import React from "react";
import "./ely.css";
import "./components/hub.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { AuthCallback } from "./components/AuthCallback";
import { AuthModal } from "./components/AuthModal";
import { Home } from "./components/Home";
import { Catalog } from "./components/Catalog";
import { Wusabat } from "./components/Wusabat";
import { Hub } from "./components/Hub";
import { CoursePlayer } from "./components/CoursePlayer";
import { Musbat } from "./components/Musbat";
import { Study } from "./components/Study";
import { CalendarPage } from "./components/CalendarPage";
import SalesPage from "./components/SalesPage";
import { PaymentReturn } from "./components/PaymentReturn";
import { PaypalReturn } from "./components/PaypalReturn";
import { BlogList, BlogPost } from "./components/Blog";
import { Terms, Privacy, RefundPolicy } from "./components/Legal";
import EventPage from "./components/EventPromo";

function AppInner() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <div className="elw">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Catalog />} />
        <Route path="/therapies" element={<Catalog />} />
        <Route path="/herbs" element={<Catalog />} />
        <Route path="/digital" element={<Catalog />} />
        <Route path="/learn" element={<Catalog />} />
        <Route path="/discover" element={<Catalog />} />
        <Route path="/live" element={<Catalog />} />
        <Route path="/transform" element={<Catalog />} />
        <Route path="/explore" element={<Catalog />} />
        <Route path="/wusabat" element={<Wusabat />} />
        <Route path="/musbat" element={<Musbat />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/hub" element={<Hub />} />
        <Route path="/course/:id" element={<CoursePlayer />} />
        <Route path="/study/:courseId" element={<Study />} />
        <Route path="/nlp/:id" element={<SalesPage />} />
        <Route path="/payment/success" element={<PaymentReturn />} />
        <Route path="/payment/cancel" element={<PaymentReturn cancelled />} />
        <Route path="/payment/paypal/return" element={<PaypalReturn />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/live-training" element={<EventPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
      <AuthModal />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
